<template>
  <div :class="['intersite-nav', { 'intersite-nav--expanded': expanded }]">
    <div class="intersite-nav__wrapper">
      <div
        @click.stop="toggleExpanded()"
        class="intersite-nav__tab"
        :style="`border-color:${theme.color}`"
      >
        {{ $beet.options.intersitesNav.tab_label }}
        <img src="@/assets/icons/arrowNav.svg" alt="arrow down" class="intersite-nav__arrow" />
      </div>
      <div
        @click.stop.self="toggleExpanded()"
        class="intersite-nav__content"
        :style="`border-color: ${theme.color}`"
      >
        <Card
          :img="
            $beet.options.intersitesNav.image_majoris.sm ??
            $beet.options.intersitesNav.image_majoris.original
          "
          type="dark"
        >
          <h3 class="card__title">{{ $beet.options.intersitesNav.majoris.title }}</h3>
          <p class="card__text">{{ $beet.options.intersitesNav.majoris.description }}</p>
          <a
            href="https://majorisassurances.ca/"
            class="intersite-nav__button button-circle"
            :style="`border: 1px solid ${theme.color}`"
            >{{ $beet.options.intersitesNav.visit_website }}</a
          >
        </Card>
        <Card
          :img="
            $beet.options.intersitesNav.image_dvsf.sm ??
            $beet.options.intersitesNav.image_dvsf.original
          "
          type="dark"
        >
          <h3 class="card__title">{{ $beet.options.intersitesNav.dvsf.title }}</h3>
          <p class="card__text">{{ $beet.options.intersitesNav.dvsf.description }}</p>
          <a
            href="https://dvsf.ca"
            class="intersite-nav__button button-circle"
            :style="`border: 1px solid ${theme.color}`"
            >{{ $beet.options.intersitesNav.visit_website }}</a
          >
        </Card>
      </div>
    </div>
    <div @click.stop="toggleExpanded()" class="intersite-nav__bg-darken"></div>
  </div>
</template>
<script>
import Card from '../Card.vue'

export default {
  name: 'IntersiteNav',
  components: { Card },
  data() {
    return {
      expanded: false,
    }
  },
  props: {
    theme: {
      type: Object,
    },
  },
  methods: {
    toggleExpanded() {
      this.expanded = !this.expanded
      // Scroll to top of the div when not expanded to fix graphical glitch
      if (!this.expanded) {
        this.$el.scrollTo(0, 0)
      }
    },
  },
}
</script>
